import {PolymerElement, html} from '@polymer/polymer';
import '@polymer/polymer/lib/elements/dom-if.js';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';
import {FieldGridBehavior} from '../behaviors/field-grid-behavior.js';
import {FieldcontainerSharedStylesHTML} from '../shared-styles/field-container.js';

class KeliSection extends ScopeBinding(FieldGridBehavior(PolymerElement)) {
  static get template() {
    return html`
${FieldcontainerSharedStylesHTML}
<style>
:host {
  display: block;
}

:host(.hidden) {
  display: none;
}

#fields.hidden {
  display: none;
}

#fields {
  display: grid;
  grid-gap: 0 20px;
  grid-template-columns: repeat(var(--field-container-column-count, auto-fit), minmax(150px, 1fr));
  grid-auto-flow: column;
  grid-template-rows: repeat(var(--field-container-row-count), minmax(40px, auto));
  overflow: visible;
}
</style>

<template is="dom-if" if="[[caption]]">
  <keli-header caption="[[caption]]"></keli-header>
</template>
<div id="fields" class$="[[_computeFieldClass(totalFields, caption)]]">
  <slot></slot>
</div>`;
  }

  static get is() {
    return 'keli-section';
  }

  static get properties() {
    return {
      caption: {type: String, scopevar: true},
      columns: {type: Number, scopevar: true, observer: 'columnsChanged'},
      isBlockPanelElement: {type: Boolean, value: true},
      isRegionElement: {type: Boolean, value: true},
      keliControlTypes: {type: Array, value: ['section']}
    }
  }

  _computeFieldClass(totalFields, caption) {
    this.classList.toggle('hidden', (totalFields === 0 && !caption));
    return (totalFields === 0 ? 'hidden' : '');
  }

  columnsChanged() {
    this.recalculateRowsAndColumns();
  }
}

customElements.define(KeliSection.is, KeliSection);
export {KeliSection};
